module.exports = __webpack_public_path__ + "img/icon-right-arrow-black.97d2186a.svg";